/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_WeekdaysInputs */

const vi_irrigation_schedule_weekdays = /** @type {(inputs: Irrigation_Schedule_WeekdaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày áp dụng`)
};

/**

* @param {Irrigation_Schedule_WeekdaysInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_weekdays = /** @type {((inputs?: Irrigation_Schedule_WeekdaysInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_WeekdaysInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_weekdays(inputs)
});